import * as styledComponents from 'styled-components'

type Theme = {
    mainColor: string
    secondColor: string
    mainDarkColor: string
    secondDarkColor: string
    textColor: string
    linkColorCommon: string
}

const {
    default: styled,
    css,
    createGlobalStyle,
    keyframes,
    ThemeProvider
} = styledComponents as styledComponents.ThemedStyledComponentsModule<Partial<Theme>>

export { css, createGlobalStyle, keyframes, ThemeProvider }
export default styled
